import * as constants from '../constants';
import converter from '../converter';

const initialState = false;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCalculatorMordovia.try: {
            return true;
        }

        case constants.getCalculatorMordovia.success:
        case constants.getCalculatorMordovia.error: {
            return false;
        }

        default:
            return state;
    }
}
